<template>
  <div class="item-detail col-6">
    <div class="text-center">
      <WCImage
        :imageSrc="
          giftCard.design.image
            ? `${$configuration.cdn}/api/img/${giftCard.design.image}`
            : `${$configuration.cdn}/images/placeholder.png`
        "
        imageClass="img-thumbnail"
        :imageAlt="$t('giftCardImgAltText')"
        defaultClass="font-size-7xl"
      />
    </div>
    <div class="item-text text-center">
      <div>
        <strong>{{ giftCard.amount | currency }} {{ $t('eGiftCard') }}</strong>
      </div>
      <div>
        <strong>{{ $t('toCap') }}:</strong> {{ giftCard.recipientName }},
        <strong>{{ $t('from') }}:</strong>
        {{ giftCard.senderName }}
      </div>
      <div v-if="giftCard.sendDate">
        <strong>{{ $t('willBeSentOn') }} {{ giftCard.sendDate | formatDateTime }}</strong>
      </div>
      <button class="btn btn-primary" @click="open">{{ $t('viewEGiftCard') }}</button>
    </div>
  </div>
</template>
<script>
import ModalService from '@/modules/modals/services/modal.service';
import WCImage from '@/components/WCImage/WCImage.vue';
import WCOrderPanelGiftCardModal from '../WCOrderPanel/WCOrderPanelGiftCardModal.vue';

export default {
  name: 'WCMobileOrderPanelGiftCard',
  components: { WCImage },
  props: {
    giftCard: {},
  },
  methods: {
    async open() {
      try {
        await ModalService.open(WCOrderPanelGiftCardModal, { giftCardProfile: this.giftCard });
      } catch (error) {
        // NOOP
      }
    },
  },
};
</script>
